module.exports = __webpack_public_path__ + "static/media/sms.39630a30.svg";